var map = {
	"./bassic-badge.png": "566a",
	"./i1.png": "e48d",
	"./i2.png": "0da2",
	"./i3.png": "113b",
	"./m1.png": "4208",
	"./m2.png": "05f6",
	"./m3.png": "72e6",
	"./m4.png": "a8f4",
	"./m5.png": "210e",
	"./marker.png": "6ae8",
	"./pharmaMarker.png": "c9d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";